import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule, { settings } from ".";

export const definition: WidgetDefinition = {
  id: "piracy-audience-indicator",
  module: widgetModule,
  catalog: {
    description:
      "One or two figures of the piracy audience report, such as viewers disrupted, with their trend.",
    domain: "audience",
    visual: "KPI",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "kpi" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-4",
};
